﻿// © Microsoft Corporation. All rights reserved.

// Defines constants used in telemetry beacons

export default {
    // logSamplingRate was configured via %app_error_log_sampling_rate% in Prime. Hardcoding "0" here.
    logSamplingRate: "0",
    FireTelemetry: "fireTelemetryBeacon",
    GET: "GET",
    POST: "POST",
    Ctag: "ctag",
    Comscore: "scorecard",
    OTF: "udc",
    Exp: "EX:",
    ResetIdx: "resetTelemetryEventIndex"
};
